import {
  ISahraTableReports,
  ISahraTableSearchParams,
} from "../../Interfaces/SahraTableInterfaces";
import {
  getSahraUsersExcel,
  getSahraUsersTable,
} from "../../Requests/Sahra/sahraUsersRequests";
import TableTemplate from "../TableTemplate/tableTemplate";
import { SahraUsersTableSarchParamUI } from "./SahraUsersTableSearchParamUI";
import React from "react";
import { FileDownloader } from "src/Components";
import { FileExcelOutlined } from "@ant-design/icons";
// UI Framework
// Common Components
import { CommonTableUI } from "../TableTemplate/common";
// Local Components
import { SahraUsersTableAdditional } from "./SahraUsersTableAdditional";
// Utilities
import * as R from "ramda";
// Types
import { ITableUI } from "../TableTemplate/tableTemplate";

interface Props {
  refresh: boolean;
}

const SahraUsersTable: React.FC<Props> = ({ refresh }) => {
  const [searchParam, setSearchParam] = React.useState<ISahraTableSearchParams>(
    { justActive: true } as ISahraTableSearchParams,
  );
  const [serverSearchParams, setServerSearchParams] =
    React.useState<ISahraTableSearchParams>({
      justActive: true,
    } as ISahraTableSearchParams);

  const handleSearch = () => {
    const cleanObject = R.pickBy(
      (v) => !(v === null || v === "" || (Array.isArray(v) && v.length === 0)),
      searchParam,
    );
    setServerSearchParams(cleanObject as ISahraTableSearchParams);
  };

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({
      ...searchParam,
      [name]: value,
    });
  };

  return (
    <div className="flex flex-row items-start justify-start gap-3 w-full h-fit px-7">
      <SahraUsersTableSarchParamUI
        searchParam={searchParam}
        searchParamChangeHandler={searchParamChangeHandler}
        onSubmit={handleSearch}
      />
      <div className="flex flex-col gap-3 w-full">
        <div className="w-36">
          <FileDownloader
            getFile={() => getSahraUsersExcel(serverSearchParams)}
            text={
              <div className="px-2 py-0.5 text-center w-36 border-2 rounded-md border-sky-600 text-sky-600 no-underline cursor-pointer flex items-center justify-center gap-2">
                <FileExcelOutlined />
                دانلود اکسل
              </div>
            }
          />
        </div>
        <TableTemplate<ISahraTableSearchParams, ISahraTableReports>
          getDataTable={getSahraUsersTable}
          TableUI={({
            reports,
            onAction,
            sortingType,
            setSortingType,
          }: ITableUI<ISahraTableReports>) => (
            <CommonTableUI
              refreshFlag={refresh}
              reports={reports}
              onAction={onAction}
              sortingType={sortingType}
              setSortingType={setSortingType}
              AdditionalBody={SahraUsersTableAdditional}
              tableBoxClassName="max-h-[500px]"
            />
          )}
          withSort
          tableWrapperClassname="!mx-0 !justify-start !gap-0 w-full"
          searchParameters={serverSearchParams}
        />
      </div>
    </div>
  );
};

export default SahraUsersTable;
